// Slice 41 — monospace ID truncator with a hover title.

export function MonoId({
  value,
  short = 14,
  color,
}: { value: string; short?: number; color?: string }) {
  return (
    <span
      className="hq-mono"
      style={{ color: color ?? "var(--hq-text-muted)", fontSize: 11 }}
      title={value}
    >
      {value.length > short ? `${value.slice(0, short)}…` : value}
    </span>
  );
}
